<template>
  <v-layout row wrap class="mb-5">
    <v-flex xs12 class="mb-1">
      <div class="section-header">
        <span v-show="$vuetify.breakpoint.smAndDown">
          <v-icon class="greyIcon">
            campaign
          </v-icon>
        </span>
        <span class="ml-1 label" :class="{'header-label': $vuetify.breakpoint.smAndDown}">
          Campaign Details
        </span>
      </div>
      <div class="line" v-if="$vuetify.breakpoint.xsOnly" />
    </v-flex>
    <v-flex xs12 class="app-card elevation-3 rounded">
      <div class="app-card-content custom-card-content">
        <div v-if="selectedObjectiveId == objectiveType.calls.id">
          <calls-objective-details
            :mobile-number="mobileNumber"
            :call-hours="callHours"
            :selected-services="selectedServices"
            :offer-tagline="offerTagline"
          />
        </div>
        <div v-if="selectedObjectiveId == objectiveType.leadGeneration.id">
          <leads-objective-details
            :offer-tagline="offerTagline"
          />
        </div>
        <div v-if="selectedObjectiveId == objectiveType.websiteVisits.id">
          <website-visits-objective-details
            :selected-services="selectedServices"
            :destination-url="websiteVisitDestinationUrl"
            :offer-tagline="offerTagline"
          />
        </div>
        <div v-if="selectedObjectiveId == objectiveType.instantMessages.id">
          <message-objective-details
            :selected-services="selectedServices"
            :offer-tagline="offerTagline"
            :messaging-apps="recieveMessagesOn"
          />
        </div>
        <div v-if="!selectedObjectiveId">
          <v-layout row wrap>
            <v-flex
              xs12
              mb-3
            >
              <v-layout row wrap>
                <v-flex
                  xs12
                  md3
                >
                  <span class="ml-1 label">
                    {{ $t('message.bizgainOnboarding.summaryPage.Objective') }}:
                  </span>
                </v-flex>
                <v-flex
                  xs12
                  md9
                >
                  <v-layout>
                    <v-flex xs1 />
                    <v-flex xs9>
                      <span class="label detail-field" :class="{'ml-1': $vuetify.breakpoint.xsOnly}">
                        {{ $t('message.bizgainOnboarding.summaryPage.notSelected') }}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  VIcon,
  VLayout,
  VFlex
} from 'vuetify/lib';
import { bizgainOnboardingImage, objectiveType, bizgainOnboardingRoutes, leadFormEnabledFields, fallbackCountryCode } from 'Features/bizgainOnboarding/constants';
import { mapGetters } from 'vuex';
import CallsObjectiveDetails from './CallsObjectiveDetails.vue';
import LeadsObjectiveDetails from './LeadsObjectiveDetails.vue';
import WebsiteVisitsObjectiveDetails from './WebsiteVisitsObjectiveDetails.vue';
import MessageObjectiveDetails from './MessagesObjectiveDetails.vue';

export default {
  components: {
    VIcon,
    VLayout,
    VFlex,
    CallsObjectiveDetails,
    LeadsObjectiveDetails,
    WebsiteVisitsObjectiveDetails,
    MessageObjectiveDetails
  },
  data() {
    return {
      objectiveType,
      bizgainOnboardingImage,
      selectedObjectiveId: null,
      newBusinessDetails: null,
      bizgainOnboardingRoutes,
      mobileNumber: '',
      phoneObject: null,
      countryCode: '',
      leadFormEnabledFields,
      callHours: null,
      isUpdateSelectedObjective: false,
      formFields: [],
      websiteVisitDestinationUrl: '',
      selectedServices: '',
      offerTagline: '',
      recieveMessagesOn: []
    }
  },
  computed: {
    ...mapGetters(['businessDetails', 'googlePlaceDetails', 'facebookPageDetails', 'promoteServices', 'offerDetail'])
  },
  async created(){
    if (this.businessDetails){
      if (this.businessDetails.mobileNumber && this.businessDetails.mobileNumber.length > 0) {
        this.mobileNumber = this.businessDetails.mobileNumber;
      }
      else if (this.businessDetails.businessPhoneNumber && this.businessDetails.businessPhoneNumber.length > 0) {
        this.mobileNumber = this.businessDetails.businessPhoneNumber;
      }
      if(this.businessDetails.hasOwnProperty('offerTagline')){
        this.offerTagline = this.businessDetails.offerTagline;
      }

      if(this.businessDetails.hasOwnProperty('callHours')){
        this.callHours = this.businessDetails.callHours;
      }

      if (this.businessDetails.hasOwnProperty('creativeDetail')){
        if (this.businessDetails.creativeDetail.objective){
          this.setObjective(this.businessDetails.creativeDetail.objective);
        }
        if(this.selectedObjectiveId == this.objectiveType.instantMessages.id){
          this.recieveMessagesOn = this.businessDetails.creativeDetail.instantMessagesApps;
        }
      }

      if (this.businessDetails.websiteVisitDestinationUrl){
        this.websiteVisitDestinationUrl = this.businessDetails.websiteVisitDestinationUrl;
      }
      else if (this.businessDetails.websiteUrl){
        this.websiteVisitDestinationUrl = this.businessDetails.websiteUrl;
      }
    }

    if (!this.websiteVisitDestinationUrl){
      if (this.googlePlaceDetails && this.googlePlaceDetails.website) {
        this.websiteVisitDestinationUrl = this.googlePlaceDetails.website;
      }
      else if (this.facebookPageDetails && this.facebookPageDetails.website) {
        this.websiteVisitDestinationUrl = this.facebookPageDetails.website;
      }
    }

    if (this.businessLocation && this.businessLocation.countryCode){
      this.countryCode = this.businessLocation.countryCode;
    }
    else{
      // if countryCode is not available we're falling back to IN as countryCode
      this.countryCode = fallbackCountryCode;
    }
    if (this.promoteServices){
      this.selectedServices = this.promoteServices.join(', ')
    }
  },
  methods: {
    setObjective(objectiveId){
      this.selectedObjectiveId = objectiveId;
    }
  }
}
</script>
<style lang="scss" scoped>
.editIcon{
  color: #13abb1;
}
.imageIcon{
  height: 28px;
  width: 25px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.detail-field{
  color: black;
  align-self: center;
}
.line{
  width: 28%;
  border-bottom: solid;
  border-bottom-color: #54B4D3;
}
.section-header{
  display: flex;
  align-content: center;
}
.header-label{
  padding-top: 2px !important;
}
.greyIcon{
  color: #727891;
}
.custom-card-content{
  padding-bottom: 0 !important;
}
</style>

